/**
 * A figure with its sign: `+` above zero, `−` below, and none on zero — `−0 cm` is not a change.
 * The sign is the figure's own; whether the change was for the better is the caller's to colour.
 * Promoted out of `pages/client-detail/model/twoDates` on 24 September 2026, on its second slice,
 * `entities/lift-history`.
 */
export function signedText(text: string, value: number): string {
  if (value === 0) return text;
  return value > 0 ? `+${text}` : `−${text}`;
}
